import React, { useState } from "react";

import {
  CardElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

import { apiService } from "src/services";
import Button from "src/components/Button/Button";
import { toast } from "src/components/Toast/ToastManager";

import "./AddUserPaymentMethod.scss";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '17px',
      '::placeholder': {
        color: '#aab7c4'
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  },
  hidePostalCode: true,
};

interface IProps {
  customerId: string
  onSave: () => void
  hideTitle?: boolean
}

const AddUserPaymentMethod: React.FC<IProps> = ({ customerId, onSave, hideTitle = false }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      const cardElement = elements.getElement(CardElement);

      if (cardElement) {
        const { error: stripeError, setupIntent } = await stripe.confirmCardSetup(
          await getSetupIntentClientSecret(),
          {
            payment_method: {
              card: cardElement,
            },
          }
        );

        if (stripeError) {
          setError(stripeError.message);
          return;
        }

        if (setupIntent?.payment_method) {
          cardElement.clear();
          onSave();
        }
      }

    } catch (err) {
      toast.show({
        title: "Payment Method",
        content: "Could not created a payment method, please try again later",
        duration: 5000,
        type: "fail"
      });
    } finally {
      setLoading(false);
    }
  };

  const getSetupIntentClientSecret = async () => {
    const { client_secret } = await apiService.createSetupIntent({ customer_id: customerId });
    return client_secret ?? "";
  };

  return (
    <div className="add-new-payment-method">
      {!hideTitle && <h4>Add new card</h4>}
      <form onSubmit={handleSubmit}>
        <div className={`stripe-card-wrapper ${error ? "stripe-card-wrapper--error" : ""}`}>
          <CardElement
            options={CARD_ELEMENT_OPTIONS}
          />
        </div>
        {error && (
          <div className="error-message">{error}</div>
        )}
        <div className="form-actions">
          <Button
            type="submit"
            disabled={!stripe}
            isLoading={loading}
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddUserPaymentMethod
